import Vue from 'vue'
import Router from 'vue-router'
import routerData from './routerData'
import $uer from '../assets/js/Self-madeLibrary/userData'
import store from '../store'
Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }·
// 全局路由(无需嵌套上左右整体布局)
// const _import = require('./import-' + process.env.NODE_ENV)
const globalRoutes = []
// 主入口路由(需嵌套上左右整体布局)
const mainRoutes = {
  path: '/',
  component: () => import(/* webpackChunkName: "login" */ '@/components/homePage'),
  name: 'navindex',
  redirect: { name: 'entrance' },
  meta: { slideShow: false, title: '主入口整体布局' },
  children: [],
  beforeEnter(to, from, next) {
    next()
  }
}
mainRoutes.children = routerData
// globalRoutes[0].children = routerData
const JYTrouter = new Router({
  scrollBehavior: () => ({ y: 0 }), // 切换路由时定义滚动条的位置
  isAddDynamicMenuRoutes: false, // 是否已经添加动态(菜单)路由
  routes: globalRoutes.concat(mainRoutes)
})
JYTrouter.beforeEach((to, from, next) => {
  // if(store.state.NavMenu.menuData.length == 0 && to.name != 'login' && to.name != 'consoleStation'){
  //   store.state.NavMenu.menuData = getNavMenu(store.state.page.items)
  // }
  let _menuData = []
  _menuData = JSON.parse(JSON.stringify(store.state.page.items)) // 深拷贝
  let userData = $uer.get_data("userData");
  // 如果是贵阳观山湖项目才展示工单督办
  if (userData && userData.companyId != 346312 && _menuData[0].child[1].name == '工单督办') {
    _menuData[0].child.splice(1,1)
  }

  store.state.NavMenu.menuData = getNavMenu(_menuData, to)
  if (!to.name) {
    next(
      {
        name: 'login'
      }
    )
  } else {
    next();
  }
  // if (JYTrouter.options.isAddDynamicMenuRoutes || fnCurrentRouteType(to, globalRoutes) === 'global') {
  //   sessionStorage.setItem('menuList', JSON.stringify(routerData || '[]'))
  //   next();
  // } else {
  //   JYTrouter.options.routes = [];
  //   JYTrouter.options.isAddDynamicMenuRoutes = true;
  //   sessionStorage.setItem('menuList', JSON.stringify(routerData || '[]'))
  //   // http.handleAjax(
  //   // {
  //   // methods:'get',
  //   // url:'/api/nav',
  //   // params:{
  //   //   'projectId':''
  //   // }}).then((res)=>{
  //   //   console.log(res.data.list)
  //   //   if (res.data && res.data.code == 10000) {
  //   //     if(res.data.list.length!=0){
  //   //       fnAddDynamicMenuRoutes(filterArr(res.data.list))
  //   //       router.options.isAddDynamicMenuRoutes = true;
  //   //       sessionStorage.setItem('menuList', JSON.stringify(res.data.list || '[]'))
  //   //       // sessionStorage.setItem('permissions', JSON.stringify(res.data.permissions || '[]'))
  //   //       next({ ...to, replace: true })
  //   //     }else{
  //   //       router.push({ name: 'login' })
  //   //     }
  //   //   } else {
  //   //     sessionStorage.setItem('menuList', '[]');
  //   //     sessionStorage.setItem('permissions', '[]');
  //   //     next()
  //   //   }
  //   // })
  //   next()
  // }

})

/**
 * 判断当前路由类型, global: 全局路由, main: 主入口路由
 * @param {*} route 当前路由
 */
function fnCurrentRouteType(route, globalRoutes = []) {
  var temp = []
  for (var i = 0; i < globalRoutes.length; i++) {
    if (route.path === globalRoutes[i].path) {
      return 'global'
    } else if (globalRoutes[i].children && globalRoutes[i].children.length >= 1) {
      temp = temp.concat(globalRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteType(route, temp) : 'main'
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes(menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].list && menuList[i].list.length >= 1) {
      temp = temp.concat(menuList[i].list)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      menuList[i].url = menuList[i].url.replace(/^\//g, '')
      var route = {
        path: menuList[i].url.replace('/\//g', '-'),
        component: null,
        name: menuList[i].url.replace('/\//g', '-'),
        meta: {
          menuId: menuList[i].menuId,
          title: menuList[i].name,
          isDynamic: true,
          isTab: true,
          iframeUrl: ''
        }
      }
      // url以http[s]://开头, 通过iframe展示
      //   if (isURL(menuList[i].url)) {
      //     route['path'] = `i-${menuList[i].menuId}`
      //     route['name'] = `i-${menuList[i].menuId}`
      //     route['meta']['iframeUrl'] = menuList[i].url
      //   } else {
      //     try {
      //       route['component'] = _import(`modules/${menuList[i].url}`) || null
      //     } catch (e) { }
      //   }
      routes.push(route)
    }
  }
  if (temp.length >= 1) {
    fnAddDynamicMenuRoutes(temp, routes)
  } else {
    mainRoutes.name = 'main-dynamic'
    mainRoutes.children = routes
    JYTrouter.addRoutes([
      mainRoutes,
      { path: '*', redirect: { name: '404' } }
    ])
    sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(mainRoutes.children || '[]'))
    console.log('\n')
    console.log('%c!<-------------------- 动态(菜单)路由 s -------------------->', 'color:blue')
    console.log(mainRoutes.children)
    console.log('%c!<-------------------- 动态(菜单)路由 e -------------------->', 'color:blue')
  }
}


// 递归处理导航权限（涉及处理导航权限）
function getNavMenu(data, to) {
  for (let i = 0; i < data.length; i++) {
    if (to.name == 'projectList' && data[i].id == 'projectE0100') {
      data[i].child = []
    }
    if (data[i].child.length != 0) {

      // if (to.name == 'itemInformation' && data[i].id == 'project.base.operation') {
      //   console.log("点击查看项目")
      //   getNavMenu(data[1].child, to)
      // }else{
      //   getNavMenu(data[i].child, to)
      // }

      getNavMenu(data[i].child, to)
    }
    if ($uer.jur(data[i].id, 'c') || $uer.jur(data[i].id, 'p')) {
    } else {
      data.splice(i, 1);
      i--
    }

  }
  return data
}
export default JYTrouter



// WEBPACK FOOTER //
// ./src/router/index.js